import React from 'react';
import PropTypes from 'prop-types';
import { XIcon } from '@adsk/alloy-react-icon';
import { pillStyle } from './styles';

const EmailPill = ({ email, onRemoveEmail }) => {
  const { label, valid, duplicated } = email;
  return (
    <div
      css={pillStyle(valid && !duplicated)}
      data-testid="InviteProjectMemberModal_email_field_pill"
    >
      {label}
      <XIcon size={10} onClick={() => onRemoveEmail(email)} />
    </div>
  );
};

EmailPill.propTypes = {
  email: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    valid: PropTypes.bool.isRequired,
    duplicated: PropTypes.bool.isRequired,
  }),
  onRemoveEmail: PropTypes.func.isRequired,
};

export default EmailPill;
